module.exports = __webpack_public_path__ + "static/media/Panax-Gingseng.79ce90c7.jpg";